(() => {
  'use strict';

  if (window.__mellerPreorderCardCartV3Loaded) return;
  window.__mellerPreorderCardCartV3Loaded = true;

  const BUTTON_SELECTOR = '[data-meller-card-preorder-button="true"]';

  const getRoot = () => {
    if (window.Shopify?.routes?.root) return window.Shopify.routes.root;
    return '/';
  };

  const normalizePath = (path) => {
    const root = getRoot();

    if (!path) return root;
    if (path.startsWith('http')) return path;
    if (path.startsWith('/')) return path;

    return `${root}${path}`.replace(/\/{2,}/g, '/');
  };

  const getCartAddUrl = () => {
    const base = window.routes?.cart_add_url || `${getRoot()}cart/add`;
    const url = normalizePath(base);

    if (url.endsWith('.js')) return url;
    return `${url}.js`;
  };

  const getCartUrl = () => {
    return normalizePath(window.routes?.cart_url || `${getRoot()}cart`);
  };

  const getCartJsonUrl = () => {
    const cartUrl = getCartUrl();

    if (cartUrl.endsWith('.js')) return cartUrl;
    return `${cartUrl}.js`;
  };

  const getPotentialSectionIds = () => {
    const ids = new Set();

    [
      'cart-drawer',
      'cart-icon-bubble',
      'cart-notification',
      'cart-live-region-text'
    ].forEach((id) => ids.add(id));

    document.querySelectorAll('[id^="shopify-section-"]').forEach((section) => {
      const id = section.id.replace('shopify-section-', '');

      if (/cart|drawer|notification|bubble/i.test(id)) {
        ids.add(id);
      }
    });

    return Array.from(ids).slice(0, 8);
  };

  const replaceElement = (current, fresh) => {
    if (!current || !fresh) return false;

    current.innerHTML = fresh.innerHTML;

    for (const attr of fresh.attributes) {
      current.setAttribute(attr.name, attr.value);
    }

    return true;
  };

  const renderSections = (sections) => {
    if (!sections || typeof sections !== 'object') return;

    const parser = new DOMParser();

    Object.entries(sections).forEach(([sectionId, html]) => {
      if (!html) return;

      const doc = parser.parseFromString(html, 'text/html');

      const currentSection = document.getElementById(`shopify-section-${sectionId}`);
      const freshSection = doc.getElementById(`shopify-section-${sectionId}`);

      if (replaceElement(currentSection, freshSection)) return;

      const selectors = [
        `#${sectionId}`,
        `.${sectionId}`,
        '#CartDrawer',
        '#cart-drawer',
        'cart-drawer',
        '.cart-drawer',
        '#cart-notification',
        'cart-notification',
        '#cart-icon-bubble',
        'cart-icon-bubble',
        '.cart-count-bubble'
      ];

      for (const selector of selectors) {
        const current = document.querySelector(selector);
        const fresh = doc.querySelector(selector);

        if (replaceElement(current, fresh)) break;
      }
    });
  };

  const fetchCart = async () => {
    const response = await fetch(getCartJsonUrl(), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) return null;

    return response.json();
  };

  const updateCartCount = (cart) => {
    if (!cart || typeof cart.item_count !== 'number') return;

    const count = cart.item_count;
    const countText = String(count);

    const selectors = [
      '[data-cart-count]',
      '[data-cart-count-bubble]',
      '.cart-count',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span:not(.visually-hidden)',
      '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]',
      'cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((element) => {
      element.textContent = countText;
      element.setAttribute('data-cart-count', countText);
    });

    document.querySelectorAll('.cart-count-bubble, [data-cart-count-bubble]').forEach((bubble) => {
      bubble.classList.toggle('hidden', count === 0);
      bubble.hidden = count === 0;
    });

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart }
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { cart }
      })
    );
  };

  const tryOpenNativeCart = () => {
    const detail = { source: 'meller-preorder-card' };

    [
      'cart:open',
      'cart:drawer:open',
      'cart-drawer:open',
      'drawer:open'
    ].forEach((eventName) => {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: true,
          detail
        })
      );
    });

    const drawerSelectors = [
      'cart-drawer',
      '#CartDrawer',
      '#cart-drawer',
      '.cart-drawer',
      '[data-cart-drawer]',
      'dialog#CartDrawer',
      'dialog.cart-drawer'
    ];

    for (const selector of drawerSelectors) {
      const drawer = document.querySelector(selector);
      if (!drawer) continue;

      if (drawer.tagName === 'DIALOG' && typeof drawer.showModal === 'function' && !drawer.open) {
        drawer.showModal();
      }

      drawer.setAttribute('open', '');
      drawer.removeAttribute('hidden');
      drawer.classList.add('is-open', 'active', 'animate', 'menu-opening');

      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden', 'cart-drawer-open');

      return true;
    }

    const triggerSelectors = [
      '[aria-controls="CartDrawer"]',
      '[aria-controls="cart-drawer"]',
      '[aria-controls*="CartDrawer"]',
      '[aria-controls*="cart-drawer"]',
      'button[name="cart"]',
      'button[id*="cart" i]:not([type="submit"])',
      'summary[aria-controls*="cart" i]'
    ];

    for (const selector of triggerSelectors) {
      const trigger = document.querySelector(selector);
      if (!trigger) continue;

      trigger.click();
      return true;
    }

    return false;
  };

  const setButtonState = (button, state) => {
    if (!button) return;

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent.trim() || 'PRE ORDENAR';
    }

    if (state === 'loading') {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'AGREGANDO';
      return;
    }

    if (state === 'success') {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'AGREGADO';

      window.setTimeout(() => {
        button.textContent = button.dataset.originalText || 'PRE ORDENAR';
      }, 1100);

      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'ERROR';

      window.setTimeout(() => {
        button.textContent = button.dataset.originalText || 'PRE ORDENAR';
      }, 1400);

      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = button.dataset.originalText || 'PRE ORDENAR';
  };

  const getVariantIdFromButton = (button) => {
    const card = button.closest('product-card, .product-card');

    return (
      button.dataset.mellerVariantId ||
      card?.dataset?.mellerVariantId ||
      ''
    );
  };

  const addVariantToCart = async (button) => {
    if (!button || button.dataset.mellerLoading === 'true') return;

    const variantId = getVariantIdFromButton(button);

    if (!variantId) {
      setButtonState(button, 'error');
      return;
    }

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');

    const sections = getPotentialSectionIds();

    if (sections.length > 0) {
      formData.set('sections', sections.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    button.dataset.mellerLoading = 'true';
    setButtonState(button, 'loading');

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      });

      const data = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(data?.description || data?.message || 'No se pudo agregar al carrito.');
      }

      if (data?.sections) {
        renderSections(data.sections);
      }

      const cart = await fetchCart();

      updateCartCount(cart);
      setButtonState(button, 'success');
      tryOpenNativeCart();
    } catch (error) {
      console.warn('[Meller preorder card cart]', error);
      setButtonState(button, 'error');
    } finally {
      button.dataset.mellerLoading = 'false';
    }
  };

  const handleClick = (event) => {
    const button = event.target.closest?.(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addVariantToCart(button);
  };

  document.addEventListener('click', handleClick, true);
})();